import React from 'react';



const WhatsAppIcon = () => (
  <img src="/assets/demo/whatsapp-icon.png" width="22" height="22" alt="WhatsApp" />
);

const EmailIcon = () => (
  <img src="/assets/demo/email-icon.png" width="22" height="22" alt="Email" />
);

const DemoFooter = () => {
  return (
    <footer className="df-footer">
      {/* Top Row */}
      <div style={{ backgroundColor: '#240946', padding: '40px 0 24px 0' }}>
        <div className="demo-content-container">
          <div className="df-top">
            {/* Logo */}
            <div className="df-logo-col">
              <img src="/assets/demo/ft-logo.png" alt="Glammify" className="df-logo"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="df-logo-fallback" style={{ display: 'none' }}>
                <span className="df-logo-text">
                  <span className="df-logo-g">G</span>
                  <span className="df-logo-lammify">lammify</span>
                </span>
                <p className="df-logo-tagline">WHERE GLAMOUR MEETS AI</p>
              </div>
            </div>

            {/* Contact Info */}
            <div className="df-contact-col">
              <a href="https://wa.me/917039796526" className="df-contact-link" target="_blank" rel="noopener noreferrer">
                <WhatsAppIcon />
                <span>+91 7039796526</span>
              </a>
              <a href="mailto:sales@glammify.ai" className="df-contact-link">
                <EmailIcon />
                <span>sales@glammify.ai</span>
              </a>
            </div>

            {/* App Store Buttons */}
            <div className="df-apps-col">
              <a href="https://apps.apple.com/vu/app/glammify-ai/id6751037508" target="_blank" className="df-store-btn">
                <img src="/assets/demo/app-store-1.png" alt="Download on the App Store" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.glammify.app&hl=en_" target="_blank" className="df-store-btn">
                <img src="/assets/demo/google-play-1.png" alt="Get it on Google Play" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Row */}
      <div style={{ backgroundColor: '#1E073C', padding: '22px 0' }}>
        <div className="demo-content-container">
          <div className="df-bottom">
            <span className="df-copyright">© 2026 Glammify. All rights reserved.</span>
            <div className="df-links">
              <a href="/terms-conditions" className="df-link">Terms and Conditions</a>
              <a href="/privacy-policy" className="df-link">Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default DemoFooter;
